import "./MainLayout.scss";

import { Outlet } from "react-router-dom";
import { useUserContext } from "../context/UserContext";
import Navbar from "../components/navbar/Navbar";
import { useAppVersion } from "../hooks/useAppVersion";

function MainLayout() {
  const { user } = useUserContext();
  const { hasUpdate } = useAppVersion();

  return (
    <>
      {hasUpdate && (
        <div className="new-version-container shadow">
          Hay una nueva version de la aplicación disponible
          <button
            className="btn btn-primary"
            style={{ marginLeft: "0px" }}
            onClick={() => window.location.reload()}
          >
            Recargar
          </button>
        </div>
      )}
      <div className="layout-main-container">
        {user && <Navbar />}
        <Outlet />
      </div>
    </>
  );
}

export default MainLayout;
